"use client";

import Image from "next/image";
import Slider from "react-slick";
import useUtility from "@/app/_hooks/useUtility";
import { useSection } from "./_hooks/useSection";
import { frontendImage } from "@/lib/helpers";
import TeamSkeleton from "./_skeletons/TeamSkeleton"; // optional loading skeleton

export const TeamSection = () => {
  const { trans } = useUtility();
  const { content, elements, loading } = useSection("our_team");

  if (loading) return <TeamSkeleton />;

  const settings = {
    autoplay: true,
    loop: true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    arrows: false,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const cardStyle = {
    backgroundColor: "#002B5B", // dark blue
    borderRadius: "24px",
    padding: "20px",
    margin: "10px",
    textAlign: "center",
  };

  const imageStyle = {
    borderRadius: "18px",
    width: "100%",
    height: "auto",
    objectFit: "cover",
  };

  return (
    <section
      className="team-section section-bg py-60"
      style={{ overflow: "hidden" }}
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="section-heading four">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <h5 className="section-heading__title">
                    {trans(content?.title)}
                  </h5>
                </div>
                <div className="col-lg-6">
                  <p className="section-heading__desc">
                    {trans(content?.description)}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-11">
            <div
              className="team-slider-wrapper tw-stretch-element-inside-column"
              style={{
                marginLeft: "0px",
                marginRight: "-324px",
                overflow: "hidden",
              }}
            >
              <Slider {...settings} className="team-slider">
                {elements?.map((item, index) => (
                  <div className="team-item" style={cardStyle} key={index}>
                    <div className="team-item__thumb">
                      <Image
                        src={frontendImage(item.image, "our_team")}
                        alt={trans(item.name)}
                        width={327}
                        height={400}
                        style={imageStyle}
                      />
                    </div>
                    <div className="team-item__content">
                      <span className="team-item__title d-block">
                        {trans(item.name)}
                      </span>
                      <span className="team-item__designation d-block fw-regular">
                        {trans(item.designation)}
                      </span>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
